
export const DENSITY = {
  BELOW: true,
  ABOVE: false
}
